// extracted by mini-css-extract-plugin
module.exports = {"bottom_affix":"bottom_affix-3rQAAHfd","backToTop":"backToTop-2LazzcMp"};